import {
	CANCEL_IMPORT_PLAYERS_COMPLETE,
	DELETE_IMPORT_PLAYERS,
	DELETE_PLAYER_COMPLETE,
	DELETE_PLAYERS_COMPLETE,
	GENERATE_HEADERS,
	IMPORT_PLAYERS,
	IMPORT_PLAYERS_COMPLETE,
	INIT_PLAYERS,
	INIT_PLAYERS_COMPLETE,
	PARSE_CSV,
	SAVE_IMPORT_PLAYERS,
	SAVE_IMPORT_PLAYERS_COMPLETE,
	SAVE_PLAYER,
	SAVE_PLAYER_COMPLETE,
	SET_VIEW
} from "./constants";

const initialState = {
	players: [],
	isLoading: false,
	isImporting: false,
	importedPlayers: {},
	importErrors: {},
	csvHeaders: null,
	view: "list",
	savingPlayerIds: []
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case INIT_PLAYERS: {
			return {
				...state,
				isLoading: true
			};
		}
		case INIT_PLAYERS_COMPLETE: {
			const { players } = payload;

			const mergedPlayers = [...state.players];
			players.forEach((p) => {
				const currentPlayer = mergedPlayers.find((player) => player.id === p.id);
				if (currentPlayer) {
					Object.assign(currentPlayer, p);
				} else {
					mergedPlayers.push(p);
				}
			});

			return { ...state, players: mergedPlayers, isLoading: false };
		}
		case SAVE_PLAYER: {
			const { id } = payload;
			return {
				...state,
				savingPlayerIds: [
					...state.savingPlayerIds.filter((spId) => spId !== id),
					id
				]
			};
		}
		case SAVE_PLAYER_COMPLETE: {
			const { player } = payload;

			return {
				...state,
				players: [...state.players.filter((p) => p.id !== player.id), player],
				savingPlayerIds: [
					...state.savingPlayerIds.filter((spId) => spId !== player.id)
				],
				isLoading: false
			};
		}
		case DELETE_PLAYER_COMPLETE: {
			const { player } = payload;
			return {
				...state,
				players: state.players.filter((p) => p.id !== player.id),
				isLoading: false
			};
		}
		case DELETE_PLAYERS_COMPLETE: {
			const { playerIds } = payload;
			return {
				...state,
				players: state.players.filter((p) => !playerIds.includes(p.id)),
				isLoading: false
			};
		}
		case IMPORT_PLAYERS: {
			return {
				...state,
				importedPlayers: {},
				importErrors: {},
				isImporting: true,
				isLoading: true
			};
		}
		case DELETE_IMPORT_PLAYERS: {
			const { importedPlayers } = payload;

			return {
				...state,
				importedPlayers
			};
		}
		case IMPORT_PLAYERS_COMPLETE: {
			return {
				...state,
				...payload,
				isImporting: false,
				isLoading: false
			};
		}
		case SAVE_IMPORT_PLAYERS:
		case PARSE_CSV: {
			return {
				...state,
				isImporting: true,
				isLoading: true
			};
		}
		case SAVE_IMPORT_PLAYERS_COMPLETE:
		case CANCEL_IMPORT_PLAYERS_COMPLETE: {
			const { players } = payload;

			return {
				...state,
				importedPlayers: {},
				importErrors: {},
				players: [
					...state.players.filter((sp) => !players.find((ep) => ep.id === sp.id)),
					...players
				],
				isImporting: false,
				isLoading: false
			};
		}
		case GENERATE_HEADERS:
		case SET_VIEW: {
			return {
				...state,
				...payload
			};
		}
		default:
			return state;
	}
};

export default reducer;
